


<div class="ui modal" id="PrintSlip_Modal" style="width:274px; font-family:'Arial Narrow'">

    <div *ngFor="let list of this.tournamentsService.printSlipList">

        <table style="width:100%;border:0;border-spacing:0px" class="PrintSlip_Table_Class_Original">
            <!--LOGO-->
            <tr>
                <td colspan="4">
                    <div style="text-align:center">
                        <img src="../../../Images/Logo_Black.jpg" style="width:156px;height:76px" />
                    </div>
                </td>
            </tr>

            <tr>
                <td colspan="4" class="PrintSlip_Ticket" style="font-size:22px;font-weight:bold;text-align:center; padding-bottom: 2px;font-family:'Arial Narrow'">
                    <span>{{"Betting_slip" | t}}</span>
                </td>
            </tr>

            <tr>
                <td colspan="4" style="padding:4px;font-size: 22px;font-weight:bold;text-align:center;padding-bottom: 2px;font-family:'Arial Narrow'">
                    <span>{{list.SlipId}}</span><span>({{list.TicketPassword}})</span>
                </td>
            </tr>

            <tr>
                <td colspan="4" style="font-size:12px;padding-top:12px;font-family:'Arial Narrow'">
                    <span>{{this.tournamentsService.translations["Created_on_:"]}}</span>
                    <span>
                        {{list.CreateDate}}
                    </span>
                </td>
            </tr>

            <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

            <tr>
                <td colspan="4" style="font-size:12px;padding-bottom:0px;font-family:'Arial Narrow'">
                    <span>{{this.tournamentsService.translations["Type_:"]}}</span> <span>{{list.SlipType}}</span>
                </td>
            </tr>

            <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

            <ng-container *ngFor="let detailList of this.tournamentsService.printSlipDetailList">
                <tr>
                    <td colspan="1" style="font-size:12px;font-weight: bold;width:15%;padding-bottom: 2px;font-family:'Arial Narrow'">
                        {{detailList.MatchCode}}
                    </td>
                    <td colspan="2" style="font-size:12px;font-weight: bold;padding-bottom: 2px;font-family:'Arial Narrow'">
                        {{detailList.HomeTeam}}
                    </td>
                    <td colspan="1" style="font-size: 12px;font-weight:bold;text-align:center;font-family:'Arial Narrow'">
                        <span class="PrintSlip_Original_Banko" style="padding:2px;background-color: black !important;color: white !important;width: 50px !important;" *ngIf="detailList.Banko == 1">
                            <span>{{"Bank" | t}}</span>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="1" style="font-size:12px;padding-bottom: 2px;font-family:'Arial Narrow'" class="PrintSlip_MatchDate">{{detailList.EventDay}}</td>
                    <td colspan="3" style="font-size:12px;font-weight: bold;padding-bottom: 2px;font-family:'Arial Narrow'">{{detailList.AwayTeam}}</td>
                </tr>
                <tr>
                    <td class="PrintSlip_MatchTime" style="font-size:12px;width:15%;padding-bottom: 2px;border-bottom:1px solid #313131;font-family:'Arial Narrow'">
                        {{detailList.EventTime}}
                    </td>

                    <td class="PrintSlip_Tipp" style="font-size:12px;width:50%;padding-bottom: 2px;border-bottom:1px solid #313131;font-family:'Arial Narrow'">
                       <span>{{detailList.ShortOddType}}</span> <span style="margin-left:2px">{{detailList.SpecialBetValue}}</span>
                    </td>
                    <td style="font-size:12px;font-weight:bold;width:15%;padding-bottom: 2px;border-bottom:1px solid #313131;font-family:'Arial Narrow'">{{detailList.Outcomes}}</td>
                    <td style="font-size:12px;font-weight:bold;text-align:right;width:20%;padding-bottom: 2px;padding-right:14px;border-bottom:1px solid #313131;font-family:'Arial Narrow'">
                        {{detailList.OddValue}}
                    </td>
                </tr>


            </ng-container>

        </table>

        <table style="width:100%;border:0;" class="PrintSlip_Table_Class_Original">
            <tr>
                <td colspan="2" style="font-size:12px;width:48%;font-family:'Arial Narrow'">
                    <span>{{this.tournamentsService.translations["Total_Stake_:"]}}:</span>
                </td>
                <td colspan="2" style="padding-right:14px;text-align:right;font-size:12px;font-weight:bold;padding-bottom: 2px;width:51%;font-family:'Arial Narrow'">
                    {{list.Amount}} {{list.CurrencyCode}}
                </td>
            </tr>

            <tr>
                <td colspan="2" style="font-size:12px;font-family:'Arial Narrow'">
                    <span>{{this.tournamentsService.translations["Tax_:"]}}:</span>
                </td>
                <td colspan="2" style="padding-right:14px;text-align:right;font-size:12px;font-weight:bold;padding-bottom: 2px;font-family:'Arial Narrow'">
                    {{list.TaxAmount}} {{list.CurrencyCode}}
                </td>
            </tr>
            <tr>
                <td colspan="2" style="font-size:12px;font-family:'Arial Narrow'">
                    <span>{{this.tournamentsService.translations["Number_of_bets_:"]}}:</span>
                </td>
                <td colspan="2" style="padding-right:14px;text-align:right;font-size:12px;font-weight:bold;padding-bottom:2px;font-family:'Arial Narrow'">
                    {{list.Bets}}
                </td>
            </tr>

            <tr>
                <td colspan="2" style="font-size:16px;font-weight:bold;padding-bottom: 2px;font-family:'Arial Narrow'">
                    <span>{{this.tournamentsService.translations["Total_Amount_:"]}}:</span>
                </td>
                <td colspan="2" style="padding-right:12px;padding-left: 1px;text-align:right;padding-bottom: 2px;font-family:'Arial Narrow'">
                    <span style="font-size:16px;font-weight:bold;">
                        {{list.TotalAmount}} {{list.CurrencyCode}}
                    </span>

                </td>
            </tr>
            <tr>
                <td colspan="2" style="font-size:16px;font-weight:bold;text-align:left;padding-bottom: 2px;font-family:'Arial Narrow'">
                    <span>{{this.tournamentsService.translations["Max_Win_:"]}}:</span>
                </td>
                <td colspan="2" style="padding-right:14px;padding-left: 1px;text-align:right;padding-bottom: 2px;font-family:'Arial Narrow'">
                    <span style="font-size:16px;font-weight:bold;">{{list.Gain}} {{list.CurrencyCode}}</span>
                </td>
            </tr>

            <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>



        </table>

        <table style="margin-top:30px">
            <tr>
                <td colspan="4" style="font-size:12px;font-family:'Arial Narrow'">
                    <div style="line-height:14px;padding-right: 16px;">
                        Wetthalter: IBC Ltd. Apertment 21 Charles Court St. Lukes Road Pieta Malta
                    </div>
                </td>
            </tr>

            <tr>
                <td colspan="4" style="font-size:12px;font-family:'Arial Narrow'">
                    <br />
                    <div style="line-height:14px">Es gelten die ausgehängten Wettbestimmungen mit dem jeweils
                      aktuellen stand. </div>
                    <div style="line-height:14px">Bitte überprüfen Sie Ihr Wettverhalten!  </div>
                    <div style="line-height:14px">Suchtgefahr!</div>
                </td>
            </tr>
        </table>
        <table style="width:100%;border:0;" class="PrintSlip_Table_Class_Original">
            <tr>
                <td colspan="4" style="padding-top:8px;font-family:'Arial Narrow'">
                    <div style="width:180px;height:64px;margin:auto">
                        <svg id="PrintSlip_Barcode" style="width: 180px;margin: auto;display: block;"></svg>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>



